



















































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import CollapseCard from '@/components/layout/CollapseCard.vue';
import { Checkbox, FormItem, Input, Select, Option } from 'element-ui';
import {
  TransportationOptionFields,
  TransportationOptionInput,
  TruckTypeEnum
} from '@/types/graphql/schemaTypes';
import truckOptions from '@/constants/truckTypes';
import { SelectOption } from '@/types/types';
import currencies from '@/constants/currencyOptions';

@Component({
  components: {
    CollapseCard,
    'el-checkbox': Checkbox,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-select': Select,
    'el-option': Option
  }
})
export default class Drayage extends Vue {
  @Prop({ type: String, required: true }) private type!: 'departure' | 'arrival';
  @Prop({ required: true }) private transportOptions!: TransportationOptionFields;

  private currenciesOptions: SelectOption<string>[] = currencies();

  private transportationInput: TransportationOptionInput = {
    drayage: false,
    truckingInformations: {
      truckingArrangement: false,
      truckType: TruckTypeEnum.unknown,
      truckCount: 0
    },
    vanningInformations: {
      cost: 0,
      currency: 'JPY',
      needsVanning: false
    }
  };

  private options(): SelectOption<string>[] {
    return truckOptions().map((cat) => {
      if (cat.label) {
        return {
          label: this.$t(cat.label).toString(),
          value: cat.value
        };
      }
      return { label: '', value: '' };
    });
  }

  @Watch('transportOptions', { immediate: true })
  setInputs(transportOptions: TransportationOptionFields) {
    // only copy if value aren't empty
    if (!transportOptions) {
      return;
    }
    if (transportOptions.truckingInformations) {
      this.transportationInput.truckingInformations = {
        truckingArrangement: transportOptions.truckingInformations!.truckingArrangement || false,
        truckType: transportOptions.truckingInformations!.truckType || TruckTypeEnum.unknown,
        truckCount: transportOptions.truckingInformations!.truckCount || 0
      };
    }
    if (transportOptions.vanningInformations) {
      this.transportationInput.vanningInformations = {
        cost: transportOptions.vanningInformations!.cost || 0,
        currency: transportOptions.vanningInformations!.currency || 'JPY',
        needsVanning: transportOptions.vanningInformations!.needsVanning || false
      };
    }
  }

  @Watch('transportationInput', { deep: true, immediate: true })
  emitInputs(transportationInput: TransportationOptionInput) {
    this.$emit('update', transportationInput);
  }
}
